/**
* @author ayou[beica1@outook.com]
* @date 2022/1/4 14:09
* @description
*   Home.index.vue of WeTrade
*/
<template>
<div class="fill bg-white">
  <Scroller class="fill px-16" @bottomTouched="loadMore">
    <TheMissionCard
      v-show="showMissionCard"
      class="mt-8 mb-20"
      @show="showMissionCard = true"
      @dismiss="showMissionCard = false"
    />
    <TheBanner class="mt-8" />
    <TheEntries class="mt-16" />
    <TheRecommend class="mt-16" />
    <TheEvents class="mt-24" />
    <TheNews class="mt-24" :list="loaded" :refresh="refresh" />
  </Scroller>
  <TheBuoy />
</div>
</template>

<script lang="ts">
import TheBanner from '@/modules/home/components/TheBanner.vue'
import TheRecommend from '@/modules/home/components/TheRecommend.vue'
import TheNews from '@/modules/home/components/TheNews.vue'
import TheEntries from '@/modules/home/components/TheEntries.vue'
import TheEvents from '@/modules/home/components/TheEvents.vue'
import TheBuoy from '@/modules/home/components/TheBuoy.vue'
import TheMissionCard from '@/modules/home/components/TheMissionCard.vue'
import { sayHello, checkEvaluateStatus } from '@/modules/home/home'
import { defineComponent, onActivated, onMounted, shallowRef, watch } from 'vue'
import Scroller from 'common/providers/Scroller.vue'
import useLoadMore from 'common/hooks/useLoadMore'
import { readNewsAndAnalysis, NewsAndAnalysis } from '@/modules/home/home.api'
import { useRouter } from 'vue-router'
import state from '@/state'

export default defineComponent({
  name: 'Home',
  components: { TheNews, TheEvents, TheEntries, TheBanner, TheMissionCard, Scroller, TheBuoy, TheRecommend },
  setup () {
    const router = useRouter()
    const showMissionCard = shallowRef(true)

    const { loaded, refresh, loadMore } = useLoadMore<NewsAndAnalysis, NewsAndAnalysis[]>(
      readNewsAndAnalysis, 10, (resp) => resp)
    refresh()

    onMounted(() => {
      sayHello(router)
    })

    onActivated(() => {
      watch(() => state.login, () => {
        if (state.login) {
          checkEvaluateStatus()
        }
      }, {
        immediate: true,
      })
    })

    return {
      showMissionCard,
      loaded,
      loadMore,
      refresh (done: () => void) {
        refresh().then(done)
      },
    }
  },
})
</script>
